import { Injectable } from '@angular/core';
import { InitFacade } from './init.facade';
import { ofType, Actions } from '@ngrx/effects';
import { LangActions, LoadLangSuccessAction } from '@library/store/lang/lang.actions';
import { take } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class InitLoader {
  constructor(
    private readonly actions$: Actions,
    private readonly initFacade: InitFacade,
  ) { }

  async load(): Promise<LoadLangSuccessAction> {
    this.initFacade.start();
    return await firstValueFrom(this.actions$.pipe(
      ofType(LangActions.loadLangsSuccess),
      take(1),
    ));
  }
}

export function InitLoaderFactory(service: InitLoader): () => Promise<LoadLangSuccessAction> {
  const url = window.location.href;
  if (url.indexOf('#') !== -1) {
    history.replaceState({}, '', transformUrl(url));
  }
  return () => service.load();
}

export function transformUrl(url: string): string {
  const urlObj = new URL(url);

  const hashSegments = urlObj.hash.split('#/');
  urlObj.hash = '';
  urlObj.pathname = hashSegments.join('/');

  return urlObj.toString();
}
